<template>
  <el-container style="padding: 10px 20px">
    <el-form :inline="true" ref="form" label-width="90px">
      <el-form-item label="账户名称:">
        <el-input
          style="width: 300px"
          v-model="userBox.username"
          :disabled="true"
        ></el-input>
      </el-form-item>

      <el-form-item label="选择头像:">
        <el-upload
          ref="upload"
          class="avatar-uploader"
          action=""
          :multiple="false"
          :http-request="onSubmit"
          :on-change="filechange"
          :on-remove="handleRemove"
          :auto-upload="false"
          :show-file-list="false"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>

      <el-form-item label="联系邮箱:">
        <el-input style="width: 300px" v-model="userBox.email"></el-input>
      </el-form-item>

      <el-form-item label="账户别名:">
        <el-input style="width: 300px" v-model="userBox.aliasName"></el-input>
      </el-form-item>
      <el-form-item label="联系电话:">
        <el-input
          style="width: 300px"
          v-model="userBox.phone"
          placeholder="请输入联系电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="管理员备注:">
        <el-input
          type="textarea"
          :disabled="true"
          maxlength="100"
          show-word-limit
          style="width: 300px"
          v-model="userBox.adminNote"
        ></el-input>
      </el-form-item>
      <el-button type="primary" @click="onSubmit">修改信息</el-button>
    </el-form>
  </el-container>
</template>

<script>
export default {
  inject: ['app'],
  props: {
    dialogVisible: {
      type: Boolean,
    },
  },
  computed: {
    selfDialogVisible() {
      return this.dialogVisible
    },
  },
  data() {
    return {
      tableData: [
        { slotname: 'LDAP', slotedition: '***********' },
        { slotname: '微信', slotedition: 'v0.08' },
        { slotname: 'QQ', slotedition: 'v0.01' },
      ],
      imageUrl: '',
      labelPosition: 'left',
      activeName: '1',
      nowUserInfo: {},
      userBox: [],
      extraText: '',
      imageUrls: '',
      msg: {},
      phone: '',
    }
  },
  created() {
    let res = JSON.parse(localStorage.getItem('authInfo'))
    this.nowUserInfo = res.accountInfo
    this.getUserInfo()
  },
  mounted() {},
  methods: {
    getUserInfo() {
      this.$http
        .get(
          '/sitir-tavern-service/tavern/account/get-keycloak-account-detail-by-id',
          {
            params: {
              id: this.nowUserInfo.id,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            this.userBox = res.data.resultBody
            this.getUserImage()
          } else {
            this.$message('错误' + res.data.message)
          }
        })
    },
    filechange(file, fileList) {
      this.imageUrl = file.raw.path
      this.imageUrls = file.raw
    },
    handleRemove() {
      this.imageUrl = ''
    },
    onSubmit(params) {
      const form = new FormData()
      form.append('file', this.imageUrls)
      form.append('keycloakId', this.nowUserInfo.id)
      form.append('adminNote', this.userBox.adminNote)
      form.append('aliasName', this.userBox.aliasName)
      form.append('phone', this.userBox.phone)
      form.append('email', this.userBox.email)
      const authInfo = JSON.parse(window.localStorage.authInfo)
      let url =
        '/sitir-tavern-service/tavern/account/edit-account-keycloak-extra-info'
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer ' + authInfo.token,
        },
      }
      this.$http.post(url, form, config).then((res) => {
        if (res.status === 200) {
          this.$message('修改成功！')
          this.getUserInfo()
          this.getUserImage()
        } else {
          this.$message('错误' + res.data.message)
        }
      })
    },
    // 获取头像
    getUserImage() {
      // const config = {
      //   responseType: 'blob'
      // }
      this.$http
        .get(
          '/sitir-tavern-service/tavern/account/download-profile-img',
          {
            params: {
              keycloakExtraInfoId: this.userBox.keycloakExtraInfoId,
            },
          },
          { responseType: 'blob' }
        )
        .then((res) => {
          if (res.status === 200) {
            var blob = new Blob([res.data], { type: 'jpg' })
            console.log(blob)
            var a = window.URL.createObjectURL(blob)
            this.imageUrl = a
          } else {
            this.$message('头像获取错误' + res.data.message)
          }
        })
    },
    resetForm() {
      this.$refs.userInfo.resetFields()
    },
    toHome() {
      this.$emit('updateDialogVisible')
    },
    beforeClose() {
      this.toHome()
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
